module.exports = __webpack_public_path__ + "assets/img/videoBg.6b5737c4.png";